<template>
  <b-modal
    ref="modal"
    title="Treatments Imported Successfully!"
    size="lg"
    ok-only
    ok-title="OK"
    header-bg-variant="success"
    header-text-variant="white"
  >
    <div v-if="result">
      <div class="text-center mb-4">
        <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
      </div>

      <b-card bg-variant="light" class="mb-3">
        <h6 class="text-primary mb-3">
          <i class="fas fa-info-circle mr-2"></i>
          Import Details
        </h6>
        <dl class="row mb-0">
          <dt class="col-sm-5">Total Rows:</dt>
          <dd class="col-sm-7">{{ result.totalRows || 0 }}</dd>
          <dt class="col-sm-5">Imported Count:</dt>
          <dd class="col-sm-7">
            <strong class="text-success">{{ result.importedCount || 0 }}</strong>
          </dd>
          <template v-if="result.df !== undefined">
            <dt class="col-sm-5">DF ที่ตั้งให้:</dt>
            <dd class="col-sm-7">{{ result.df }}%</dd>
          </template>
          <template v-if="skippedByMap.length">
            <dt class="col-sm-5">ข้ามตามที่เลือก:</dt>
            <dd class="col-sm-7">{{ skippedByMap.length }}</dd>
          </template>
          <template v-if="skippedExisting.length">
            <dt class="col-sm-5">มีรหัสนี้อยู่แล้ว:</dt>
            <dd class="col-sm-7">
              <span class="text-warning">{{ skippedExisting.length }}</span> skipped
            </dd>
          </template>
          <template v-if="categoriesCreated.length">
            <dt class="col-sm-5">หมวดที่สร้างใหม่:</dt>
            <dd class="col-sm-7">{{ categoriesCreated.join(', ') }}</dd>
          </template>
        </dl>
      </b-card>

      <b-card v-if="byCategoryRows.length" bg-variant="light" class="mb-3">
        <h6 class="text-primary mb-3">
          <i class="fas fa-layer-group mr-2"></i>
          แยกตามหมวด
        </h6>
        <b-table-simple small responsive class="mb-0">
          <b-tbody>
            <b-tr v-for="row in byCategoryRows" :key="row.category">
              <b-td>{{ row.category }}</b-td>
              <b-td class="text-right">{{ row.count }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>

      <b-alert show variant="warning" class="mb-0">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        ไฟล์นี้ไม่มีค่า DF — treatments were created at <strong>0%</strong> doctor
        fee. ต้องตั้งค่า DF ในระบบก่อนใช้งานจริง มิฉะนั้นหมอจะไม่ได้ส่วนแบ่งจากรายการเหล่านี้.
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TreatmentImportResultModal',
  data() {
    return {
      result: null
    };
  },
  computed: {
    skippedByMap() {
      return (this.result && this.result.skippedByMap) || [];
    },
    skippedExisting() {
      return (this.result && this.result.skippedExisting) || [];
    },
    categoriesCreated() {
      return (this.result && this.result.categoriesCreated) || [];
    },
    byCategoryRows() {
      const byCategory = (this.result && this.result.byCategory) || {};
      return Object.entries(byCategory).map(([category, count]) => ({ category, count }));
    }
  },
  methods: {
    show(result) {
      this.result = result;
      this.$refs.modal.show();
    }
  }
};
</script>
